/**
 * CreditsScreen - Écran des crédits
 * Identique à Flutter BaseCreditsWidget
 */

import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
  Platform,
} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {faTimes, faScroll} from '@fortawesome/free-solid-svg-icons';

const CreditsScreen: React.FC = () => {
  const navigation = useNavigation();

  const handleBack = () => {
    navigation.goBack();
  };

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView contentContainerStyle={styles.contentContainer}>
        <View style={styles.header}>
          <FontAwesomeIcon icon={faScroll} size={32} color="#fff" />
          <Text style={styles.title}>Crédits</Text>
          <TouchableOpacity style={styles.closeButton} onPress={handleBack}>
            <FontAwesomeIcon icon={faTimes} size={24} color="#fff" />
          </TouchableOpacity>
        </View>

        <View style={styles.content}>
          <Text style={styles.sectionTitle}>La Vanturier</Text>
          <Text style={styles.text}>
            Application de jeux d'aventures textuels interactifs
          </Text>

          <Text style={styles.sectionTitle}>Développement</Text>
          <Text style={styles.text}>
            Développé avec React Native et TypeScript
          </Text>

          <Text style={styles.sectionTitle}>Technologies</Text>
          <Text style={styles.text}>
            • React Native{'\n'}
            • TypeScript{'\n'}
            • Supabase{'\n'}
            • Vite
          </Text>

          <Text style={styles.sectionTitle}>Version</Text>
          <Text style={styles.text}>1.0.0</Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#18191A',
  },
  contentContainer: {
    flexGrow: 1,
    padding: 20,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 30,
    position: 'relative',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#fff',
    letterSpacing: 1.2,
    marginLeft: 12,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 10,
  },
  content: {
    flex: 1,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#fff',
    marginTop: 30,
    marginBottom: 12,
  },
  text: {
    fontSize: 16,
    lineHeight: 24,
    color: 'rgba(255, 255, 255, 0.8)',
    marginBottom: 20,
  },
});

export default CreditsScreen;
